export default __webpack_public_path__ + "static/media/gvloadingimg.ba225ebf.png";